import React from 'react';
import { PRINTING_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { parseId } from 'pxc-editor-core/helpers/schema';
import PagePrintRenderer from './PagePrintRenderer';
import ShieldContentPrintRenderer from './ShieldContentPrintRenderer';

const PrintRendererComponent = (props) => {
  const { mode, printObjId } = props;
  if (printObjId) {
    const { shieldId } = parseId(printObjId);

    if(shieldId) {
      if (mode === PRINTING_MODE.TEXT_FIELD_MATRIX) {
        return <ShieldContentPrintRenderer {...props} />
      }
      return <ShieldPrintRenderer {...props} />;
    } else {
      return <PagePrintRenderer {...props} />;
    }
  }
  return null;
};

export default React.memo(PrintRendererComponent);
